// extracted by mini-css-extract-plugin
module.exports = {"tablePagination":"table_tablePagination__36O_V"};